import { ParameterDetailsBaseScreen } from "@components/building-components";

export const FloorParameterCreateScreen: React.FC<any> = () => (
  <ParameterDetailsBaseScreen mode="create" />
);
